// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { getApiUrl } from "utils";
import { API_URL } from "constants/api";

// Define a service using a base URL and expected endpoints
export const transferApi = createApi({
  reducerPath: "transfers",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getAllTokenTransfer: builder.query<
      any,
      { offset: number; limit: number; address?: string; type?: string }
    >({
      query: ({ address, offset, limit, type }) =>
        `transfer/list?offset=${offset}&limit=${limit}${
          address ? `&address=${address}` : ""
        }${type ? `&type=${type}` : ""}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllTokenTransferQuery } = transferApi;
